import { publish, subscribe } from '../patched-message-bus';
import * as productMenu from '../product-menu';
import { commandSelect } from './message-bus-helpers';

export default (function () {
  subscribe(productMenu.events.onSelected(function (_ref) {
    var link = _ref.link;

    if (!link) return;
    publish(commandSelect({ link: link }));
  }));
});
//# sourceMappingURL=workflow.js.map